import * as R from "ramda";
import React from "react";
import { connect } from "react-redux";
import { showNotification } from "react-admin";
import { Checkbox } from "@material-ui/core";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { dataProvider } from "../../App";
import { GET_REMOTE_SESSION, SET_REMOTE_SESSION } from "../../misc/constants";

class RemoteSessionForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { remote_session_enabled: false };
    this.changeSetting = this.changeSetting.bind(this);
  }

  componentDidMount() {
    dataProvider(GET_REMOTE_SESSION)
      .then(({ data }) => {
        this.setState({ ...data });
      })
      .catch(({ body }) => {
        const message = R.pathOr(null, ["message"], body);
        if (!message) return;
        this.props.showNotification(message, "warning");
        throw Promise.reject();
      });
  }

  changeSetting(event) {
    const checked = event.target.checked;
    const parameters = { remote_session_enabled: event.target.checked };
    dataProvider(SET_REMOTE_SESSION, undefined, parameters)
      .then(() => {
        this.props.showNotification(
          "Remote Session setting has been changed",
          "info"
        );
        this.setState({ ...parameters });
      })
      .catch(({ body }) => {
        const message = R.pathOr(null, ["message"], body);
        if (!message) return;
        this.props.showNotification(message, "warning");
        throw Promise.reject();
      });
  }

  render() {
    return (
      <FormGroup row>
        <FormControlLabel
          control={
            <Checkbox
              checked={this.state.remote_session_enabled}
              onChange={this.changeSetting}
              value="checkedA"
            />
          }
          label="Remote Sessions"
        />
      </FormGroup>
    );
  }
}
export default connect(
  null,
  { showNotification }
)(RemoteSessionForm);
